import { render, staticRenderFns } from "./SidebarZonesContainer.vue?vue&type=template&id=7b7bbe52&"
import script from "./SidebarZonesContainer.vue?vue&type=script&lang=ts&"
export * from "./SidebarZonesContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports